import React from "react";

const Logout = (props) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.0845 21.5H5.19996C3.71056 21.5 2.50293 20.2857 2.50293 18.7963V5.19703C2.50293 3.70763 3.71056 2.5 5.19996 2.5H9.0845C9.50046 2.5 9.83591 2.83545 9.83591 3.25141C9.83591 3.66737 9.50046 4.00282 9.0845 4.00282H5.19996C4.54248 4.00282 4.01246 4.53284 4.01246 5.19033V18.7895C4.01246 19.447 4.54248 19.977 5.19996 19.977H9.0845C9.50046 19.977 9.83591 20.3125 9.83591 20.7285C9.83591 21.1444 9.50046 21.4799 9.0845 21.4799V21.5Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.6"
      />
      <path
        d="M15.887 17.6086C15.6925 17.6086 15.4979 17.5348 15.3503 17.3872C15.0551 17.092 15.0551 16.6157 15.3503 16.3205L19.6776 11.9999L15.3503 7.67925C15.0551 7.38405 15.0551 6.90771 15.3503 6.61251C15.6455 6.31731 16.1218 6.31731 16.417 6.61251L21.2744 11.4699C21.5696 11.7651 21.5696 12.2414 21.2744 12.5366L16.417 17.3939C16.2694 17.5415 16.0749 17.6153 15.8803 17.6153L15.887 17.6086Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.6"
      />
      <path
        d="M20.7447 12.7514H9.08442C8.66846 12.7514 8.33301 12.4159 8.33301 11.9999C8.33301 11.584 8.66846 11.2485 9.08442 11.2485H20.7447C21.1607 11.2485 21.4961 11.584 21.4961 11.9999C21.4961 12.4159 21.1607 12.7514 20.7447 12.7514Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.6"
      />
    </svg>
  );
};

export default Logout;
